import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';

import { InputBackOffice } from '../../components/common/InputBackoffice';
import { FlexBetween, Label } from '../../styles/stylesStyled';
import { useState } from 'react';
import { Button, ErrorToast } from '../../components';
import { useDispatch } from 'react-redux';
import {
  createWebinarMenagement,
  purchaseWebinarTicket
} from '../../slices/webinars-slice';
import { P3 } from '../../styles/FontStyles';
import { color, colors } from '../../styles/GlobalStyles';
import { SelectToken } from '../../components/common/SelectNetwork/SelectToken';
import { SelectedUSDT } from '../../styles/GlobalComponents';
import { formatUSD, SendingTokenType } from '../../helpers/helperFunctions';
import { CheckText } from '../../components/common/CheckText';
import { useTranslation } from 'react-i18next';
import { NetworkType } from '../../types/types';

const CreateTicket = ({
  setSelectedToken,
  selectedToken,
  selectedWebinar,
  setStep
}: {
  setSelectedToken: any;
  selectedToken: any;
  selectedWebinar: any;
  setStep: any;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('marketplace');

  const [checkbox, setCheckbox] = useState(false);

  return (
    <>
      <P3 bold mb='10' color={colors.neutral900}>
        Name
      </P3>
      <SelectedUSDT>{selectedWebinar?.name}</SelectedUSDT>
      <P3 bold mb='10' mt='20' color={colors.neutral900}>
        Payment Amount
      </P3>

      <SelectedUSDT>
        {formatUSD(selectedWebinar?.ticketPriceGross)}
      </SelectedUSDT>
      <P3 bold mb='8' mt='30' color={color.colors.neutral900}>
        Selected Blockchain
      </P3>
      <SelectedUSDT>Binance Smart Chain (BEP-20)</SelectedUSDT>
      <FlexBetween style={{ width: '100%', marginBottom: 10, marginTop: 20 }}>
        <P3 bold mb='8' mt='10' color={color.colors.neutral900}>
          Select Token
        </P3>
      </FlexBetween>

      <SelectToken
        onChange={(token) => {
          setSelectedToken(token);
        }}
        value={selectedToken}
      />

      <P3 bold mb='25' color={color.colors.error500}>
        <SendingTokenType network={NetworkType?.BEP_20} />
      </P3>

      <CheckText
        checked={checkbox}
        onClick={() => setCheckbox(!checkbox)}
        text={t('payment_method.i_understand')}
      />

      <Button
        mt='20'
        disabled={!checkbox || !selectedToken}
        onClick={() =>
          dispatch(
            purchaseWebinarTicket({
              webinarId: selectedWebinar?.id,
              token: selectedToken.token,
              setStep
            })
          )
        }>
        Create order
      </Button>
    </>
  );
};

export default CreateTicket;
